import { defineStore } from 'pinia';

export interface StaticCondiment {
    rows: number;
    columns: number;
    buttonHeight: number;
    dockPosition: String;
    dockLocation: String;
    soldOutFunction: boolean;
    linkPLU: boolean;
    hideDockScrollbar: boolean;
    ReverseDockScrollbar: boolean;
    condimentGroupsList: CondimentGroup[];
}
export interface CondimentGroup {
    id: string;
    name: string;
}

export const defaultStaticCondiment = {
    rows: 0,
    columns: 0,
    buttonHeight: 0,
    dockPosition: '',
    dockLocation: '',
    soldOutFunction: false,
    linkPLU: false,
    hideDockScrollbar: false,
    ReverseDockScrollbar: false,
    condimentGroupsList: []
} as StaticCondiment;

export const condimentsListMock = [
    { id: '1', name: 'Sauces' },
    { id: '2', name: 'Toppings' },
    { id: '3', name: 'Dressings' },
    { id: '4', name: 'Spices' },
    { id: '5', name: 'Cheese' },
    { id: '6', name: 'Veggies' },
    { id: '7', name: 'Meats' },
    { id: '8', name: 'Seafood' },
    { id: '9', name: 'Extras' },
    { id: '10', name: 'Sweeteners' },
    { id: '11', name: 'Dairy' },
    { id: '12', name: 'Nuts' },
    { id: '13', name: 'Fruits' },
    { id: '14', name: 'Gluten-Free Options' },
    { id: '15', name: 'Vegan Options' },
    { id: '16', name: 'Breads' },
    { id: '17', name: 'Sides' },
    { id: '18', name: 'Drinks' },
    { id: '19', name: 'Alcoholic Beverages' },
    { id: '20', name: 'Desserts' },
    { id: '21', name: 'Appetizers' },
    { id: '22', name: 'Soups' },
    { id: '23', name: 'Salads' },
] as CondimentGroup[];

export const useStaticCondimentStore = defineStore('staticCondiment', {
    state: () => ({
        staticCondiment: {} as StaticCondiment,
    }),
    getters: {
        getStaticCondiment: (state) => {
            return state.staticCondiment;
        }
    },
    actions: {
        setStaticCondiment(staticCondiment: StaticCondiment) {
            this.staticCondiment = staticCondiment;
        }
    },
});